import { useState } from 'react';
import useToggleState from '../useToggleState';

const useExtraDialog = () => {
    const {open, handleToggle} = useToggleState();
    const [extraProductData, setExtraProductData] = useState({
        product: null,
        qty: null,
    });

    return {open, handleToggle, extraProductData, setExtraProductData};
}

export default useExtraDialog;